import AppLayout from "@/layouts/AppLayout";
import { Outlet, useLocation } from "react-router-dom";
import { PersonObjectHeading } from "@/features/person/components/PersonObjectHeading";
import TabLayout from "./_TabLayout";
import { useIsCompactLayout } from "@/hooks/useIsCompactLayout";
import Breadcrumb from "@/components/Breadcrumb";
import { usePersonErrorHandling } from "../_components/usePersonErrorHandling";
import PersonNotFoundErrorBoundary from "../_components/PersonNotFoundErrorBoundary";
import { isCareerFocusedView } from "./careerFocusedView";

export default function CareerLayout() {
  const location = useLocation();
  const { isCompactLayout: isMobile } = useIsCompactLayout();
  const { pgaId, navLinks, shouldRenderError } = usePersonErrorHandling();

  const isFocusedView = isCareerFocusedView(location.pathname);

  // If this is a focused view page, render it directly without the app layout
  if (isFocusedView) {
    return <Outlet />;
  }

  // Early return for error cases
  if (shouldRenderError) {
    return (
      <AppLayout navLinks={[]} interior bottomBar>
        <PersonNotFoundErrorBoundary />
      </AppLayout>
    );
  }

  return (
    <AppLayout navLinks={navLinks} interior bottomBar>
      {isMobile && (
        <Breadcrumb compactOnly compactTitle="Career" backLink={{ to: "/people/:pgaId", params: { pgaId: pgaId! } }} />
      )}
      <PersonObjectHeading pgaId={pgaId!} />
      <TabLayout>
        <Outlet />
      </TabLayout>
    </AppLayout>
  );
}
